import React from 'react'
import axios from 'axios'

var Master = React.createContext()
var MasterDispatch = React.createContext()

const defaultMasterData = {
	"jobFuncs": [

	],
	"jobSubFuncs": [

	],
	"executiveLevels": [

	],
	"jobGrades": [

	],
	"roles": [

	]
}

function MasterReducer(state, action) {
    switch (action.type) {
        case 'MASTER_DATA':
            const { masterData } = action
			return { ...state, masterData: masterData }
		default:
			return { ...state, masterData: {} }
    }
}

function MasterProvider({ children }) {
    var [state, dispatch] = React.useReducer(MasterReducer, { masterData: defaultMasterData })
    return (
        <Master.Provider value={state}>
            <MasterDispatch.Provider value={dispatch}>
                {children}
            </MasterDispatch.Provider>
        </Master.Provider>
    )
}

function useMasterState() {
    var context = React.useContext(Master)
    if (context === undefined) {
        throw new Error('useMasterState must be used within a MasterProvider')
    }
    return context
}

function useMasterDispatch() {
    var context = React.useContext(MasterDispatch)
    if (context === undefined) {
        throw new Error('useMasterDispatch must be used within a MasterDispatchProvider')
    }
    return context
}

function fetchMasterData(dispatch) {
    axios(`/api/master_data`)
        .then((result) => {
            const payload = {
                type: 'MASTER_DATA',
                masterData: result.data.data
            }
            dispatch(payload)
        })
        .catch((error) => {
            console.log('Error in fetching master data', error)
        })
}

export { MasterProvider, useMasterState, useMasterDispatch, fetchMasterData }

